module.exports = __webpack_public_path__ + "fonts/trash-hand.28e6ad13.ttf";